import commonPostTypeConfig from '../../common/postTypes/license'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'license',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
